'use strict';

import {element_exists} from "../functions";
import {
    fnErrorMsg,
    getSelectedCompany, printResponse, reloadVouchersTableWithMissingVoucherText,
    validateCompany
} from "../jquery-functions-library";
var Inputmask = require('inputmask');


export var releaseVouchers = function () {

    if (!element_exists('#btn-release-all') || !element_exists('#selected_company')) {
        return false;
    }

    $('#btn-release-all').on('click', function (e) {

        var lang = allLangFiles.vouchers.js;

        var company_id = getSelectedCompany();

        var form =
            '<form type="POST" class="m-t-15"><div class="form-group">' +
            '<label for="voucher-deadline">' + lang.release_label + '<input id="voucher-deadline" type="text" class="form-control" placeholder="dd/mm/yyyy" required></label><br>' +
            '</div></form>';

        validateCompany(lang, {
            title: lang.send_to_customer,
            content: lang.send_to_customer_content,
            theme: 'supervan',
            columnClass: 'col-md-12',
            backgroundDismiss: true,
            buttons: {
                formSubmit: {
                    text: lang.yes,
                    btnClass: 'btn-blue',
                    action: function () {
                        validateCompany(lang, {

                            onOpen: function () {
                                var im = new Inputmask({mask: "99/99/9999", placeholder: "dd/mm/yyyy"});
                                im.mask($("#voucher-deadline"));
                            },

                            title: lang.release_title,
                            content: form + lang.release_content,
                            theme: 'supervan',
                            columnClass: 'col-md-12',
                            backgroundDismiss: true,
                            buttons: {

                                formSubmit: {
                                    text: lang.yes,
                                    btnClass: 'btn-blue',
                                    action: function () {
                                        var deadline = this.$content.find('#voucher-deadline').val();
                                        if (!deadline) {
                                            $.alert(lang.release_alert);
                                            return false;
                                        }
                                        $.ajax({
                                            type: 'POST',
                                            data: {company_id: company_id, deadline: deadline},
                                            url: '/voucher/release/all',
                                            success: function (response) {

                                                printResponse(response);

                                                reloadVouchersTableWithMissingVoucherText();
                                            },
                                            error: fnErrorMsg
                                        });
                                    }
                                },
                                Cancel: {
                                    text: lang.cancel
                                }
                            },
                            onContentReady: function () {
                                // bind to events
                                var jc = this;
                                this.$content.find('form').on('submit', function (e) {
                                    // if the user submits the form by pressing enter in the field.
                                    e.preventDefault();
                                    jc.$$formSubmit.trigger('click'); // reference the button and click it
                                });
                            }
                        });
                    }
                },
                Nej: {
                    text: lang.no,
                    action: function () {
                        $.ajax({
                            type: 'POST',
                            data: {company_id: company_id},
                            url: '/voucher/release/all',
                            success: function (response) {

                                printResponse(response);

                                reloadVouchersTableWithMissingVoucherText();
                            },
                            error: fnErrorMsg
                        });
                    }
                },
                Cancel: {
                    text: lang.cancel
                }
            },
        });
    });
};
